import { getAnalyticsTopCards, getAnalyticsLeftChart, getAnalyticsRightChart, getAnalyticsTable } from "../../actions/Users/authenticateAnalytics";
import { GET_ANALYTICS_TOP_CARDS, GET_ANALYTICS_BAR_CHART, GET_ANALYTICS_LINE_CHART, GET_ANALYTICS_TABLE } from '../../actions/types';
import { getAvilWindow } from './utils';

export const processAnalyticsTopWidgetPayload = async (dispatch, analyticsData, selectedOu, vessels, sites, newSummaryStartDate, newSummaryEndDate, newSummaryWanType, activeTab, subTab) => {
    if (!vessels?.length) return;
    const Vessels = !sites?.length ? vessels : sites;
    const siteIdStr = Vessels.map((item) => `'${item.id}'`).join(",");
    const avail_window = Math.ceil(((new Date(newSummaryEndDate).getTime() - new Date(newSummaryStartDate).getTime()) / 60e3) / 5) || 12;

    const topWidgetQueries = analyticsData?.[activeTab]?.[subTab]?.namedQueries?.['topWidget'];

    if (!Array.isArray(topWidgetQueries) || topWidgetQueries?.length === 0) {
        dispatch({
            type: GET_ANALYTICS_TOP_CARDS,
            payload: {},
        });
        return;
    }

    if (!Array.isArray(topWidgetQueries) || topWidgetQueries.length === 0) return;

    const payloadKeys = Array.from(new Set(topWidgetQueries.flatMap(({ parameters }) => parameters)));

    const fullPayload = Object.fromEntries(
        payloadKeys.map((key) => [
            key,
            {
                dpId: selectedOu?.id,
                k4Id: siteIdStr,
                k4Ids: siteIdStr,
                siteid: siteIdStr,
                location_ids: siteIdStr,
                startDate: newSummaryStartDate,
                endDate: newSummaryEndDate,
                startTime: newSummaryStartDate,
                endTime: newSummaryEndDate,
                start_time: newSummaryStartDate,
                end_time: newSummaryEndDate,
                wanType: newSummaryWanType?.value,
                wan_type: newSummaryWanType?.value,
                avail_window,
                suppressed: "Suppression",
                activity: "1,0",
                overage: false
            }[key] ?? ""
        ])
    );

    try {
        await dispatch(getAnalyticsTopCards(topWidgetQueries, fullPayload, analyticsData, activeTab, subTab));
    } catch (error) {
        console.error('❌ Error in processAnalyticsPayload:', error);
    }
};

export const processAnalyticsLeftChartPayload = async (dispatch, analyticsData, selectedOu, vessels, sites, newSummaryStartDate, newSummaryEndDate, newSummaryWanType, activeTab, subTab) => {
    if (!vessels?.length) return;
    const Vessels = !sites?.length ? vessels : sites;
    const siteIdStr = Vessels.map((item) => `'${item.id}'`).join(",");
    const avail_window = Math.ceil(((new Date(newSummaryEndDate).getTime() - new Date(newSummaryStartDate).getTime()) / 60e3) / 5) || 12;

    const leftChartQueries = analyticsData?.[activeTab]?.[subTab]?.namedQueries?.['leftChart'];

    if (!Array.isArray(leftChartQueries) || leftChartQueries?.length === 0) {
        dispatch({
            type: GET_ANALYTICS_BAR_CHART,
            payload: {},
        });
        return;
    }

    const recLimitFormat = leftChartQueries.find(q => q.recLimitFormat)?.recLimitFormat || "10";
    const limitFormat = leftChartQueries.find(q => q.limitFormat)?.limitFormat || "limit 10";
    const payloadKeys = Array.from(new Set(leftChartQueries.flatMap(({ parameters }) => parameters)));

    const fullPayload = Object.fromEntries(
        payloadKeys.map((key) => [
            key,
            {
                dpId: selectedOu?.id,
                k4Id: siteIdStr,
                siteid: siteIdStr,
                location_ids: siteIdStr,
                startDate: newSummaryStartDate,
                endDate: newSummaryEndDate,
                startTime: newSummaryStartDate,
                endTime: newSummaryEndDate,
                start_time: newSummaryStartDate,
                end_time: newSummaryEndDate,
                wanType: newSummaryWanType?.value,
                wan_type: newSummaryWanType?.value,
                recLimit: recLimitFormat,
                limit: limitFormat,
                pageOffset: 0,
                pageSize: 10,
                avail_window,
                suppressed: "Suppression",
                activity: "1,0"
            }[key] ?? ""
        ])
    );

    try {
        await dispatch(getAnalyticsLeftChart(leftChartQueries, fullPayload, analyticsData, activeTab, subTab));
    } catch (error) {
        console.error('❌ Error in processAnalyticsPayload:', error);
    }
};

export const processAnalyticsRightChartPayload = async (dispatch, analyticsData, selectedOu, vessels, sites, newSummaryStartDate, newSummaryEndDate, newSummaryWanType, selectedBin, activeTab, subTab) => {
    if (!vessels?.length) return;
    const Vessels = !sites?.length ? vessels : sites;
    const siteIdStr = Vessels.map((item) => `'${item.id}'`).join(",");
    const avail_window = getAvilWindow(selectedBin) || 12;;

    const rightChartQueries = analyticsData?.[activeTab]?.[subTab]?.namedQueries?.['rightChart'];

    if (!Array.isArray(rightChartQueries) || rightChartQueries?.length === 0) {
        dispatch({
            type: GET_ANALYTICS_LINE_CHART,
            payload: {},
        });
        return;
    }

    const recLimitFormat = rightChartQueries.find(q => q.recLimitFormat)?.recLimitFormat || "10";
    const limitFormat = rightChartQueries.find(q => q.limitFormat)?.limitFormat || "limit 10";

    const payloadKeys = Array.from(new Set(rightChartQueries.flatMap(({ parameters }) => parameters)));

    const fullPayload = Object.fromEntries(
        payloadKeys.map((key) => [
            key,
            (() => {
                const basePayload = {
                    dpId: selectedOu?.id,
                    k4Id: siteIdStr,
                    siteid: siteIdStr,
                    location_ids: siteIdStr,
                    startDate: newSummaryStartDate,
                    endDate: newSummaryEndDate,
                    startTime: newSummaryStartDate,
                    endTime: newSummaryEndDate,
                    start_time: newSummaryStartDate,
                    end_time: newSummaryEndDate,
                    wanType: newSummaryWanType?.value,
                    wan_type: newSummaryWanType?.value,
                    bucketInterval: selectedBin,
                    recLimit: recLimitFormat,
                    limit: limitFormat,
                    avail_window,
                    activity: "1,0"
                };
    
                // Handle interval & intervalNum logic
                if (payloadKeys.includes("intervalNum") && payloadKeys.includes("interval")) {
                    basePayload.intervalNum = selectedBin.split(" ")[0];
                    basePayload.interval = selectedBin.split(" ")[1];
                } else if (payloadKeys.includes("interval")) {
                    basePayload.interval = selectedBin;
                }
    
                return basePayload[key] ?? "";
            })()
        ])
    );    

    try {
        await dispatch(getAnalyticsRightChart(rightChartQueries, fullPayload, analyticsData, activeTab, subTab));
    } catch (error) {
        console.error('❌ Error in processAnalyticsPayload:', error);
    }
};

export const processAnalyticsTablePayload = async (dispatch, analyticsData, selectedOu, vessels, sites, newSummaryStartDate, newSummaryEndDate, newSummaryWanType, page, limit, sort, sortOrder, activeTab, subTab, searchText, isDownloadMode = false) => {
    if (!vessels?.length) return;
    const Vessels = !sites?.length ? vessels : sites;
    const siteIdStr = Vessels.map((item) => `'${item.id}'`).join(",");
    const avail_window = Math.ceil(((new Date(newSummaryEndDate).getTime() - new Date(newSummaryStartDate).getTime()) / 60e3) / 5) || 12;

    const tableQueries = analyticsData?.[activeTab]?.[subTab]?.namedQueries?.['table'];
    const defaultSortCOlumn = analyticsData?.[activeTab]?.[subTab]?.table?.tableKeys?.defaultSortColumn;

    if (!Array.isArray(tableQueries) || tableQueries?.length === 0) {
        dispatch({
            type: GET_ANALYTICS_TABLE,
            payload: {},
        });
        return;
    }

    const payloadKeys = Array.from(new Set(tableQueries.flatMap(({ parameters }) => parameters)));

    const fullPayload = Object.fromEntries(
        payloadKeys.map((key) => [
            key,
            {
                dpId: selectedOu?.id,
                k4Id: siteIdStr,
                k4Ids: siteIdStr,
                siteid: siteIdStr,
                location_ids: siteIdStr,
                sites: siteIdStr,
                startDate: newSummaryStartDate,
                endDate: newSummaryEndDate,
                startTime: newSummaryStartDate,
                endTime: newSummaryEndDate,
                start_time: newSummaryStartDate,
                end_time: newSummaryEndDate,
                wanType: newSummaryWanType?.value,
                wan_type: newSummaryWanType?.value,
                pageOffset: (page-1) * limit,
                pageoffset: (page-1) * limit,
                pageStart: (page-1) * limit,
                offset: (page-1) * limit,
                pageSize: limit,
                pagesize: limit,
                pageLimit: limit,
                limit: limit,
                sortColumn: sort ? sort : defaultSortCOlumn,
                sortcolumn: sort ? sort : defaultSortCOlumn,
                sortBy: sort ? sort : defaultSortCOlumn,
                sort_column: sort ? sort : defaultSortCOlumn,
                sort: sort ? sort : defaultSortCOlumn,
                order: sortOrder || "desc",
                sort_order: sortOrder || "desc",
                search: searchText,
                sortOrder: sortOrder || "desc",
                suppressed: "Suppression",
                activity: "1,0",
                avail_window
            }[key] ?? ""
        ])
    );

    try {
        const response = await dispatch(getAnalyticsTable(tableQueries, fullPayload, analyticsData, activeTab, subTab));
        const countKey = analyticsData?.[activeTab]?.[subTab]?.table?.tableKeys?.totalCount;
        if (isDownloadMode) {
            const config = analyticsData?.[activeTab]?.[subTab]?.table?.tableKeys;
            const columns = config?.columns || [];
            const totalCountValue = response?.[response.length - 1]?.[countKey];
            const data = totalCountValue ? response.slice(0, -1) : response.slice(1);
            return { data, columns };
        }
    } catch (error) {
        console.error('❌ Error in processAnalyticsPayload:', error);
    }
};

export const processMergeData = (flattenedResults, analyticsData, activeTab, subTab) => {
    let mergedData = {};

    flattenedResults.forEach((obj) => {
        if (typeof obj === 'object' && obj !== null) {
            
            const refKeys = analyticsData[activeTab][subTab]?.['topCard']?.['cardKeys']
                .map((key) => key.refKey)
                .filter((refKey) => refKey !== undefined);

            Object.entries(obj).forEach(([key, value]) => {
                if (refKeys.includes(String(value))) {
                    obj[key] = String(value);
                }
            });

            const matchedRefKeyEntry = Object.entries(obj).find(([_, value]) =>
                refKeys.includes(value) 
            );

            if (matchedRefKeyEntry) {
                const [matchedKey, matchedRefKey] = matchedRefKeyEntry;                
                Object.entries(obj).forEach(([key, value]) => {
                    if (key !== matchedKey) {
                        mergedData[`${matchedRefKey}+${key}`] = value;
                    }
                });
            } else {
                Object.assign(mergedData, obj);
            }
        }
    });

    return mergedData;
}